<section class="header-info">
  <div class="title-info" mat-dialog-title>
    <span>Sobre o Sistema</span>
    <span style="font-size: 14px; color: #868E96;">{{version}}</span>
  </div>

  <div class="wrapper-info">
    <section class="textjustify">
      <img
        src="/assets/img/header/serrapilheira-logo.svg"
        height="32px"
        alt="Logotipo Serrapilheira"

      />

      <p>
        Esta plataforma apresenta a quantificação de serviços ambientais e a detecção de áreas prioritárias para a restauração  na Amazônia com base em três pilares: 
<br><br>
(i) valoração dos serviços ambientais de florestas de terra firme relacionados ao carbono, biodiversidade e água; 
<br><br>
(ii) sugestão de espécies-chave a serem usadas na restauração, que possam aumentar a resiliência das florestas frente às mudanças climáticas futuras e proporcionar benefícios econômicos para as comunidades locais; e 
<br><br>
(iii) integração do conhecimento tradicional com a ciência ocidental.
<!-- 
          <P><strong>Metodologia</strong></P>

          <P><b>Filtragem de Áreas:</b></P>
          <p style="margin-left: 10px;">
          Definição dos Territórios: O projeto delimita as áreas de estudo, englobando uma diversidade de territórios com diferentes níveis de degradação e características ambientais.
          Indicador de Áreas Prioritárias: Através de um indicador específico, são selecionadas as áreas que mais necessitam de ações de restauração, considerando fatores como pressão antrópica, biodiversidade e fragilidade ambiental.

          <p tyle="margin-left: 10px;"><b>Análise de Dados Ambientais:</b><br>

          Coleta de Dados: São coletados dados climáticos (temperatura do ar e precipitação) e de produtividade primária líquida (NPP) para as áreas selecionadas.
          Criação de Gráficos: Os dados coletados são utilizados para gerar gráficos que permitem visualizar as variações climáticas e a produtividade das diferentes áreas.
          Histograma de NPP: Um histograma de NPP é construído para identificar a distribuição da produtividade primária líquida nas áreas de estudo, auxiliando na seleção das espécies mais adequadas para cada local.
          Seleção de Espécies de Sementes:

          Ranking de Espécies: Com base nos dados ambientais e nos objetivos de restauração, é elaborado um ranking das espécies de sementes mais adequadas para cada área.
          Critérios de Seleção: A seleção das espécies leva em consideração fatores como adaptação às condições climáticas, capacidade de dispersão, interação com outros organismos e potencial de recuperação do solo.
          Restauração Ecológica:

          Utilização da Serapilheira: A serrapilheira coletada em áreas de referência é utilizada como substrato para a germinação das sementes selecionadas.
          Plantio: As sementes são plantadas em áreas degradadas, utilizando a serrapilheira como cobertura morta para proteger o solo e fornecer nutrientes.
          Monitoramento: O desenvolvimento das plantas é monitorado ao longo do tempo para avaliar a eficácia da técnica e ajustar as estratégias de restauração, se necessário.
          Resultados Esperados:

          Restauração acelerada: A utilização da serrapilheira e a seleção de espécies adequadas devem acelerar os processos de recuperação da vegetação e do solo em áreas degradadas.
          Aumento da biodiversidade: A introdução de espécies nativas e a criação de um ambiente favorável à colonização por outras espécies devem contribuir para o aumento da biodiversidade local.
          Melhoria da qualidade do solo: A serrapilheira promove a melhoria da qualidade do solo, aumentando a matéria orgânica, a retenção de água e a atividade biológica.
          Sustentabilidade ambiental: O projeto contribui para a sustentabilidade ambiental ao restaurar áreas degradadas, proteger recursos hídricos e mitigar os efeitos das mudanças climáticas.
          Aplicabilidade:

          A metodologia desenvolvida neste projeto pode ser aplicada em diferentes regiões do Brasil e em outros países com características ambientais semelhantes. A utilização da serrapilheira como ferramenta de restauração ecológica apresenta um baixo custo e alta eficiência, sendo uma alternativa promissora para a recuperação de áreas degradadas.


      </p>

      <p>
        <strong>Possíveis Impactos:</strong>

          Socioambientais: O projeto pode gerar impactos positivos na qualidade de vida das comunidades locais, através da melhoria da qualidade do ar e da água, da proteção da biodiversidade e da geração de oportunidades de trabalho.
          Científicos: A pesquisa pode gerar novos conhecimentos sobre a ecologia da restauração, contribuindo para o avanço da ciência e o desenvolvimento de novas tecnologias.
          Políticos: Os resultados do projeto podem influenciar a formulação de políticas públicas para a restauração de ecossistemas e a conservação da biodiversidade.
          Observações:

          Escalabilidade: A metodologia pode ser adaptada para diferentes escalas, desde pequenas áreas até grandes paisagens.
          Parcerias: A implementação do projeto requer a participação de diferentes atores, como pesquisadores, gestores ambientais, comunidades locais e empresas.
          Monitoramento contínuo: O monitoramento a longo prazo é fundamental para avaliar a eficácia das ações de restauração e ajustar as estratégias, se necessário..
      </p> -->


    </section>
  </div>
</section>
